module.exports = __webpack_public_path__ + "img/v4_trade4.82b8ffd6.png";